import { DuwGender, Gender } from 'rlv-common';
import { SessionStorageKeys } from '../types/SessionStorage';
import { Storage } from './Storage';

export const getDuwGender = (): DuwGender => {
  if (getGender() === Gender.MALE) {
    return DuwGender.MAENNLICH;
  }
  if (getGender() === Gender.FEMALE) {
    return DuwGender.WEIBLICH;
  }

  const error = 'Gender must be set';
  throw new Error(error);
};

export const getGender = (): Gender | undefined => {
  const gender = Storage.readItem(SessionStorageKeys.GENDER) || '';

  return (gender as Gender) || undefined;
};

export const getVPGender = (): Gender | undefined => {
  const gender = Storage.readItem(SessionStorageKeys.VPGENDER) || '';
  const num = parseFloat(gender);
  return Number.isNaN(num) ? undefined : num as unknown as Gender;
};

export const getPDPGender = (): number | undefined => {
  if (getGender() === Gender.MALE) {
    return 2;
  }
  if (getGender() === Gender.FEMALE) {
    return 1;
  }
  return undefined;
};
